export const Resize = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  install () {}
}

export default Resize
